/* The measurement drawings are 200-260 KB of inline SVG each. They only ever
   appear inside the size-chart overlay, so shipping them in the initial HTML
   cost every product page a quarter of a megabyte. They now live in cacheable
   .svg assets and are fetched the first time the drawing actually becomes
   visible. After injection the existing hz-mvs-v2.js is re-run through its
   public re-init hook so all measurement logic behaves exactly as before. */
(function () {
  'use strict';

  var LOADING = 'data-hz-mvs-loading';
  var DONE = 'data-hz-mvs-loaded';
  var TRIES = 'data-hz-mvs-tries';
  var MAX_TRIES = 3;

  function reinit(container) {
    // hz-mvs-v2.js skips containers it already touched; clear the flag and use
    // its own section-load listener to run the full init again.
    try { container.__hzMvsInited = false; } catch (e) {}

    /* V19: our own event, so anything new can hook the injection without
       depending on a platform event. */
    document.dispatchEvent(new CustomEvent('hz:mvs:ready', {
      detail: { container: container },
    }));

    /* V19 FIX (partial): this still fires Shopify's own section event, which on
       the storefront normally never fires at all. One injection therefore makes
       hz-variant-count.js re-sweep, hz-new-price.js switch on a document-wide
       observer for three seconds, hz-card-gallery-pin.js re-scan, and every
       installed app re-initialise.

       It cannot be dropped yet: hz-mvs-v2.js is a minified asset whose only
       public re-init hook is exactly this listener, so removing the dispatch
       here would leave the size chart broken until that file also listens for
       'hz:mvs:ready'. Both changes have to ship together.

       What IS fixed here: it used to be `new Event(...)` without a detail, so
       any listener reading event.detail.sectionId threw a TypeError. It is now
       a CustomEvent carrying a detail object. */
    document.dispatchEvent(new CustomEvent('shopify:section:load', {
      detail: { sectionId: null, source: 'hz-mvs-lazy' },
    }));
  }

  function load(host) {
    if (!host || host.hasAttribute(DONE) || host.hasAttribute(LOADING)) return;
    var src = host.getAttribute('data-hz-mvs-svg-src');
    if (!src) return;
    host.setAttribute(LOADING, '1');
    fetch(src, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('mvs ' + r.status);
        return r.text();
      })
      .then(function (svg) {
        // The asset is a standalone SVG document, so it starts with an XML
        // prolog (and possibly a doctype). Those are not valid inside an HTML
        // document; strip them so only the <svg> element itself is injected.
        host.innerHTML = String(svg)
          .replace(/^﻿/, '')
          .replace(/<\?xml[\s\S]*?\?>/i, '')
          .replace(/<!DOCTYPE[\s\S]*?>/i, '')
          .trim();
        host.removeAttribute(LOADING);
        host.removeAttribute(TRIES);
        host.setAttribute(DONE, '1');

        /* V19 FIX: unobserve moved here. It used to run BEFORE the fetch
           resolved, so a 404 or a dropped connection left the drawing blank
           for good, with no retry and no message. */
        if (io) io.unobserve(host);

        var container = host.closest('[data-hz-mvs]');
        if (container) reinit(container);
      })
      .catch(function () {
        host.removeAttribute(LOADING);
        var tries = parseInt(host.getAttribute(TRIES) || '0', 10) + 1;
        host.setAttribute(TRIES, String(tries));
        if (tries < MAX_TRIES) {
          setTimeout(function () { load(host); }, 700 * tries);
        }
      });
  }

  function hosts() {
    return document.querySelectorAll('[data-hz-mvs-svg-src]:not([' + DONE + '])');
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load(entry.target);
        });
      }, { rootMargin: '200px' })
    : null;

  function scan() {
    hosts().forEach(function (host) {
      if (io) {
        io.observe(host);
      } else {
        load(host);
      }
    });
  }

  // A dialog that opens makes its contents visible; IntersectionObserver picks
  // that up, but observing the attribute directly removes any dependency on
  // how the size chart is triggered.
  function watchDialogs() {
    var mo = new MutationObserver(function (records) {
      records.forEach(function (rec) {
        var el = rec.target;
        if (el.tagName === 'DIALOG' && el.hasAttribute('open')) {
          el.querySelectorAll('[data-hz-mvs-svg-src]:not([' + DONE + '])').forEach(load);
        }
      });
    });
    mo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true,
    });
  }

  function init() {
    scan();
    watchDialogs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scan);
})();
